const grid = {
  outer: '1300px',
  inner: '1200px',
  small: '480px',
};

export type SystemGridMap = typeof grid;
export type SystemGrid = keyof SystemGridMap;
export default grid;
